import z from "zod";

const translationPath = "page.4uBus.integrationRule.errors.";

const physicalPersonSingleBaseAutomationCodes = [14, 15, 16, 17];

const uBusAutomationSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.number(),
  },
  { invalid_type_error: translationPath + "u_bus_automation" },
);

const iProcesseSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "i_processe" },
);

export const integrationRuleSchema = z
  .object({
    id: z.string().optional(),
    enable: z.boolean(),
    name: z.string().min(1, translationPath + "name"),
    description: z.string().nullish(),
    startDate: z.date({
      invalid_type_error: translationPath + "start_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    suspensionReasonCode: z.string().nullish(),
    batchSize: z.coerce.number().nullish(),
    maxWorkers: z.coerce.number().nullish(),
    onlyRequestableLabExams: z.boolean().nullish(),
    uBusAutomation: uBusAutomationSchema,
    iProcesse: iProcesseSchema,
  })
  .superRefine((val, ctx) => {
    if (val.startDate > val.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "start_date_bigger",
        path: ["startDate"],
      });
    }
    if (val.uBusAutomation.code === 12 && !val.suspensionReasonCode) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "suspension_reason_code",
        path: ["suspensionReasonCode"],
      });
    }
    if (
      physicalPersonSingleBaseAutomationCodes.includes(val.uBusAutomation.code)
    ) {
      const batchSize = val.batchSize;
      const maxWorkers = val.maxWorkers;

      if (
        typeof batchSize !== "number" ||
        !Number.isInteger(batchSize) ||
        batchSize < 1
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "batch_size_min",
          path: ["batchSize"],
        });
      }
      if (
        typeof maxWorkers !== "number" ||
        !Number.isInteger(maxWorkers) ||
        maxWorkers < 1
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "max_workers_min",
          path: ["maxWorkers"],
        });
      } else if (maxWorkers > 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "max_workers_max",
          path: ["maxWorkers"],
        });
      }
    }
  });

export type TIntegrationRuleForm = z.infer<typeof integrationRuleSchema>;
